import axios from 'axios'
import Swal from 'sweetalert2'


export default function onSubmitWorking(user, setEditBiodata, setBiodata, setDisabled, province, districts) {
    Swal.showLoading()
    const token = localStorage.getItem('token');
    let biodata = user
    let updateWorking = {
        expec_salary: biodata.expec_salary,
        nationality: biodata.nationality,
        soft_skills: biodata.soft_skills,
        hard_skills: biodata.hard_skills,
        hobbies_interest: biodata.hobbies_interest,
        org_exp: biodata.org_exp,
        education_non_formal: biodata.education_non_formal,
        current_position: biodata.current_position,
        notice_period: biodata.notice_period
    }
    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/participant/profile/update/working`,
        headers: { token: token },
        data: {
            working: updateWorking
        }
    };

    axios(config)
        .then(function (response) {
            setEditBiodata(false)
            setDisabled(true)
            setBiodata(response.data)
            Swal.close()
        })
        .catch(function (error) {
            console.log(error);
        });
}